import create from 'zustand';
import { profileModel, teleConsultationModel } from '../Axios/AxiosConfig';
import Appointments from '../Tele_Consultation/Appointments';

const VikritiStore = create((set, get) => ({
    Vikriti_data: [],
    Disease_data: [],
    isDisease_dataloading: true,
    isVikriti_dataloading: true,

    getVikritidata: async () => {
        try {
            let res = await profileModel.get(`/fetchVikritidata`);

            if (res?.status === 200 && res?.data) {
                set({
                    Vikriti_data: res?.data,
                    isVikriti_dataloading: false,
                });
            } else {
                set({
                    isVikriti_dataloading: false,
                });
                console.log('Failed to fetch Vikriti data. Status code:', res.status);
            }
        } catch (err) {
            console.log(err?.response?.data);
            set({
                isVikriti_dataloading: false,
            });
        }
    },

    getDiseasedata: async () => {
        try {
            let res = await profileModel.get(`/fetchDiseasedata`);

            if (res?.status === 200 && res?.data) {
                set({
                    Disease_data: res?.data,
                    isDisease_dataloading: false,
                });
            } else {
                set({
                    isDisease_dataloading: false,
                });
                console.log('Failed to fetch Disease data. Status code:', res.status);
            }
        } catch (err) {
            console.log(err?.response?.data);
            set({
                isDisease_dataloading: false,
            });
        }
    }

}))

export default VikritiStore